<main id="main">
  <router-outlet></router-outlet>
</main>
<lib-preloader [loading]="loading"></lib-preloader>
